<template>
    <div class="filtering-rules-list">
        <div class="flex justify-between filtering-rules-item" :style="index == 0 ? {border: 'none'}: {}" v-for="(item, index) in tableData" :key="index">
            <el-form-item label="过滤时间" label-width="60px" style="margin-bottom: 0;">
                <gj-select
                    v-model="item.value" 
                    :options="filterUserTimeOptions"
                    :disabled="disabled"
                    style="width: 103px;">
                </gj-select>
            </el-form-item>
            <el-form-item label="类型" label-width="60px" style="margin-bottom: 0;">
                <gj-select v-model="item.type" :options="filterUserOptions" @change="filterUserChange" :disabled="disabled"
                    style="width: 155x;">
                </gj-select>
            </el-form-item>
            <div class="flex align-center" style="width: 85px;" v-if="!disabled">
                <i class="el-icon-circle-plus-outline" v-if="tableData.length < 3" @click="add"></i>
                <i class="el-icon-remove-outline" v-if="index >= 0 && tableData.length > 1" @click="deleleRow(index, item.type)"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { filterUserTimeOptions } from './../viewConfig'

export default {
    name: "filtering-rules",
    props: {
        filterUserList: Array,
        disabled: Boolean
    },
    data() {
        return {
            filterUserOptions: [
                { text: '留过Feedback差评用户', id: 'FILTER_FEEDBACK_BAD_REVIEW_BUYERS', disabled: false },
                { text: '匹配到Review差评用户', id: 'FILTER_REVIEW_BAD_REVIEW_BUYERS', disabled: false },
                { text: '有邮件往来的用户', id: 'FILTER_MAIL_CONNECT_BUYERS', disabled: false },
            ],
            filterUserTimeOptions,
            tableData: this.filterUserList
        }
    },
    watch: {
        filterUserList(val) {
            let arr = val.map(item => item.type)
             this.filterUserOptions.forEach(item => {
                if(arr.includes(item.id)) {
                    item.disabled = true
                }
            })
        }
    },
    methods: {
        add() {
            if (this.tableData.length === 3) {
                this.$gjMessage.warning('最多只能添加3条数据');
                return false
            }
            this.tableData.push({
                type: '',
                value: ''
            })
        },
        deleleRow(index, type) {
            if (this.tableData.length === 1) {
                this.$gjMessage.warning('只有一条时不能删除');
                return false
            }
            this.filterUserOptions.forEach(item => {
                if(item.id === type) {
                    item.disabled = false
                }
            })
            this.tableData.splice(index, 1)
        },
        filterUserChange(ev) {
            let typeList = this.tableData.map(item => item.type)
            this.filterUserOptions.forEach(item => {
                if(typeList.includes(item.id)) {
                    item.disabled = true
                } else {
                    item.disabled = false
                }
            })
        },
        backFilteringTable() {
            return this.tableData;
        }
    }
}
</script>

<style lang="scss">
.filtering-rules-list {
    width: 591px;
    border: 1px solid #D8DADD;
    background: #FFFFFF;
    box-sizing: border-box;

    .filtering-rules-item {
        padding: 12px 17px;
        box-sizing: border-box;
        border-top: 1px solid #D8DADD;
    }
    .el-icon-remove-outline {
        margin-left: 15px;
    }

    .el-icon-remove-outline,
    .el-icon-circle-plus-outline {
        font-size: 20px;
        cursor: pointer;
    }
}
</style>